var map = {
	"./demos/basic/index.ts": 20328,
	"./demos/closable/index.ts": 31648,
	"./demos/icon/index.ts": 16299,
	"./demos/size/index.ts": 92822,
	"./demos/title/index.ts": 6277
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12009;